export const GET_MOBILITY_DATABASE_STRUCTURE_REQUEST = "GET_MOBILITY_DATABASE_STRUCTURE_REQUEST";
export const GET_MOBILITY_DATABASE_STRUCTURE_SUCCESS = "GET_MOBILITY_DATABASE_STRUCTURE_SUCCESS";
export const GET_MOBILITY_DATABASE_STRUCTURE_FAILURE = "GET_MOBILITY_DATABASE_STRUCTURE_FAILURE";
